import { Select, Tag } from 'antd';

import { ExploreCollection } from '@addmile/backend-client';

import { COLOR_PRESETS } from '../../../const';

interface CollectionsSelectProps {
  value: string[];
  onChange: (value: string[]) => void;
  collections: ExploreCollection[];
  collectionPositions?: Record<string, number>;
  onPositionChange?: (collectionSlug: string, position: number) => void;
}

const CollectionsSelect = ({
  value = [],
  onChange,
  collections,
  collectionPositions = {},
  onPositionChange,
}: CollectionsSelectProps) => {
  const selectedCollections = collections.filter((c) => value.includes(c.slug));

  const handleToggle = (slug: string) => {
    if (value.includes(slug)) {
      onChange(value.filter((s) => s !== slug));
    } else {
      onChange([...value, slug]);
      // Set default position when adding a collection
      if (onPositionChange && !collectionPositions[slug]) {
        onPositionChange(slug, 1);
      }
    }
  };

  return (
    <div className="w-full mb-4">
      {selectedCollections.length > 0 && (
        <div className="flex flex-col gap-3 mb-3">
          {[...selectedCollections].reverse().map((collection, index) => {
            const backgroundColor = COLOR_PRESETS[index % COLOR_PRESETS.length] || COLOR_PRESETS[0];
            return (
              <div
                key={collection.slug}
                className="text-neutral-70 border-none px-3 py-2 rounded-lg flex items-center justify-between gap-3"
                style={{ backgroundColor }}
              >
                <div className="flex items-center gap-2 flex-1">
                  <span className="font-medium">{collection.title}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <Select
        mode="multiple"
        value={value}
        onChange={onChange}
        placeholder={'Select collections...'}
        className="w-full"
        tagRender={() => <></>}
        options={collections.map((c) => ({
          value: c.slug,
          label: c.title,
        }))}
        dropdownRender={() => (
          <div className="max-h-60 overflow-y-auto">
            {collections.map((collection) => {
              const isChecked = value.includes(collection.slug);
              return (
                <div
                  key={collection.slug}
                  className="px-3 py-2 cursor-pointer flex items-center gap-2"
                  onClick={() => handleToggle(collection.slug)}
                  role="checkbox"
                  aria-checked={isChecked}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleToggle(collection.slug);
                    }
                  }}
                >
                  <input
                    type="checkbox"
                    checked={isChecked}
                    readOnly
                    tabIndex={-1}
                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
                  />
                  <Tag className={`text-neutral-70 border-none px-2 py-0.5 rounded bg-white-100`}>
                    {collection.title}
                  </Tag>
                </div>
              );
            })}
          </div>
        )}
      />
    </div>
  );
};

export default CollectionsSelect;
